import React, { isValidElement } from 'react';
import cn from 'clsx';

import styles from '@sicredi/styles/_tag.scss';

export type Props = {
  children?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
  appearance?:
    | 'default'
    | 'info'
    | 'danger'
    | 'priority'
    | 'success'
    | 'warning';
};

const Tag: React.FC<Props> = ({
  icon,
  children,
  className = '',
  appearance = 'default',
  ...props
}) => {
  return (
    <div
      className={cn(
        styles['sicredi-tag'],
        styles[`-${appearance}`],
        className
      )}
      {...props}
    >
      {isValidElement(icon) && (
        <span
          aria-hidden="true"
          className={styles['icon']}
          data-testid={props['data-testid'] && `${props['data-testid']}-icon`}
        >
          {icon}
        </span>
      )}
      {children}
    </div>
  );
};

export default Tag;
